
import React, { useState, useEffect } from 'react'
function Navbar() {

    const [mouseDown, setMouseDown] = useState(0)

    useEffect(() => {
        const handleScroll = event => {
            setMouseDown(window.scrollY)
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    function refresh() {
        window.location.reload()
        window.location.href = window.location.href.split('#')[0];
    }

    return (
        <nav className={mouseDown === 0 ? 'navbar' : 'changeNav'}>
            <div className='allnav'>
                <img className='logo' src='././images/logo2.png' onClick={refresh} />
                <div className='buttons' id='buttons'>
                    <a className='a-nav' href='#home'><button id="home-btn" className='nav-btn'>Home</button></a>
                    <a className='a-nav' href='#roadmap'><button id="roadmap-btn" className='nav-btn'>Road Map</button></a>
                    <a className='a-nav' href='#cloathing'><button id="cloathing-btn" className='nav-btn'>Cloathing Brand</button></a>
                    <a className='a-nav' href='#about'><button id="about-btn" className='nav-btn'>About</button></a>
                </div >
            </div>
        </nav>
    )
}

export default Navbar




